import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import questThumbnailPng2x from './assets/QuestThumbnail@2x.png'
import questThumbnailWebp from './assets/QuestThumbnail.webp'
import questThumbnailWebp2x from './assets/QuestThumbnail@2x.webp'

const NoBadData: FC<PropsWithChildren> = () => {
  return (
    <StyledSectionBase variant="centered">
      <StyledSectionContents>
        <picture>
          <source type="image/webp" srcSet={`${questThumbnailWebp}, ${questThumbnailWebp2x} 2x`} />
          <Image width="600" height="640" src={questThumbnailPng2x} alt="Wilco Quest Thumbnail" loading="lazy" />
        </picture>
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
    padding-bottom: 0;
  }
`

const StyledSectionContents = styled(Section.Contents)`
  max-width: 1440px;
`

export default NoBadData
